import React from "react"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import MaturityBadge from "views/atoms/badges/MaturityBadge"

// Per-website tile: validated over covered criteria (e.g. 16/17), badged on that ratio.
const ChartSDG13WebsiteCriteriaKpiMolecule = ({ coverage, translationKey }) => {
  const { t } = useTranslation()

  const validated = coverage?.validated
  const covered = coverage?.covered
  const hasCoverage = covered != null && covered > 0

  const content = {
    kpi: hasCoverage ? `${validated}/${covered}` : "-",
    kpi_text: t(`${translationKey}.title`),
    reference: (
      <MaturityBadge
        value={hasCoverage ? Math.round((100 * validated) / covered) : null}
      />
    ),
  }

  return (
    <HelpWidgetChartInteractiveMolecule text={t(`${translationKey}.help`)}>
      <TextChart content={<TextChartMinor content={content} />} />
    </HelpWidgetChartInteractiveMolecule>
  )
}

ChartSDG13WebsiteCriteriaKpiMolecule.propTypes = {
  coverage: PropTypes.shape({
    validated: PropTypes.number,
    covered: PropTypes.number,
  }),
  translationKey: PropTypes.string.isRequired,
}

export default ChartSDG13WebsiteCriteriaKpiMolecule
